import template from './garage-type.jade';
import { types, garageTypes, boxTypes } from '../../../enums/garage-type';
import validation from '../../../services/validation';

export default angular
    .module('cian.addForm.garageType', [])
    .directive('cianAfAboutObjectGarageType', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller(deviceService) {
            'ngInject';

            this.isMobile = deviceService.isMobile;

            this.types = types;
            this.garageTypes = garageTypes;
            this.boxTypes = boxTypes;

            this.validation = validation(this.form, 'garage.type', {
                required: 'Обязательное поле',
            });
        },
        controllerAs: 'garageType',
        template,
    }))
    .name;
